import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Pagination from './../../shared/pagination'
import Loader from './../../shared/loader'
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'RTO',
	components: {
		Paginate,
		Loader,
		Pagination,
		DatePicker,
		BasicSelect
	},
	data: function() {
		return {
			// currentPage: 0,
			// totalRows:0,
			// pageno: 0,
			// totalPage: 0,

			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			isLoading: false,
			resultCount: '',
			clientListData: [],
			clientid: '',
			searchFlag: false,
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			client: '',
			warehouse: '',
			warehouseid: '',
			listWarehouseData: [],
			orderids: '',
			listOrderData: '',
			shippingData: [],
			shippingDataInscan: [],
			addmodalShow: false,
			poid: '',
			loginUserEmail: '',
			selectedOrderid: '',
			rtoInscan: '',
			awbno: '',
			shippingcompany: '',
			listCourierData: [],
			shippingid: '',
			srMarkedFlag: false,
			merchantid : 0,
			item:{},
		   merchant:'',
		   listMerchantData1:[],
		   listMerchantData:[],
		   merchantList:[],
		   merchantname:'',
		}
	},
	created: function() {},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.warehouseid = userdetail.warehouseid;
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		this.getcourierList()
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getcourierList();
			this.getconfig()
		  });
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.loginUserEmail = userdetail.email;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.loginUserEmail = userdetail.email;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = userdetail.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		reset(){
			this.item={}
		},
		onSelect(item){

			this.item=item
			this.merchant=item.value
		},
		getMerchantList() {
			this.listMerchantData1=[]
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
                        var merchantlistArray=[];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
					   result.data.forEach(function(item){
						   merchantlistArray[item.merchantid]=item.merchantname;

					   })
					   this.merchantList=merchantlistArray;
					   this.listMerchantData.forEach(ele=>{
						this.listMerchantData1.push({
							"value":ele.merchantid,
							"text":ele.merchantname
						})
					   })

					}

				}, error => {
					console.error(error)
				})
		},

		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},

		getconfig() {
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getconfig',
					'data': {
						warehouseidlocal: localStorage.getItem("selectedWarehouse"),
						localclientid: ''
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					this.setconfig(response.data, "rtoInscan");

				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		setconfig(response, moduleType) {

			if (moduleType == 'rtoInscan') {
				for (var i = 0; i < response.length; i++) {
					if (response[i].module == 'rtoInscan') {
						this.rtoInscan = response[i].value
					}
				}
			}


		},

		getOrderListSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getOrderList();
		},
		//to get RTO marked List
		getOrderList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.resultCount = 0;
			this.totalPage = 0;
			this.searchFlag = true;
			this.listOrderData = [];
			this.totalRows = 0
			var i = 0;
			var allorders = '';

			// var orderid = this.orderids.trim().split(',');
			// for (i = 0; i < orderid.length; i++) {
			//   if (i == orderid.length - 1) {
			//     allorders += "'" + orderid[i] + "'";
			//   } else {
			//     allorders += "'" + orderid[i] + "',";
			//   }
			// }
			if (localStorage.getItem("selectedClient")== '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.pageCount = 0;
				this.listGRRejectReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.pageCount = 0;
				this.listGRRejectReportData = [];
				return false;
			}
			if (this.orderids == "" && this.shippingcompany == "" && this.awbno == "") {
				this.$alertify.error(this.$t('rejectlistrto.orderIdAWBCourierCompany'));
				return false;
			}
			if (this.orderids == "") {
				if (this.shippingcompany == "" || this.awbno == "") {
					this.$alertify.error(this.$t('rejectlistrto.enterAWBCourierCompany'));
					return false;
				}
			}

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				orderids: this.orderids.trim(),
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				awbno: this.awbno,
				shippingcompany: this.shippingcompany,
				merchantid: this.merchant,
			})

			//console.log(this.input);return false;
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getorderListForRto',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					if (result.data.errorCode == 0) {
						this.isLoading = true;
						var orderid = result.data.data.result[0].orderid;

						this.input = ({
							orderid: orderid,
							clientid: localStorage.getItem("selectedClient"),
						});
						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'getSRMarkedCheck',
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr
								}
							})
							.then(resultSRCheck => {

								if (resultSRCheck.data.errorCode == 0) {
									this.srMarkedFlag = false;
								} else {
									this.srMarkedFlag = true;
								}
								this.listOrderData = result.data.data.result;
								this.totalRows = result.data.data.totalRows;
								this.resultCount = result.data.data.totalRows;
								this.isLoading = false;
								if (result.data.data.totalRows == 0)
									this.totalPage = 0;
								if (this.totalRows < 10) {
									this.totalPage = 1
								} else {
									this.totalPage = Math.ceil(this.totalRows / 10)
								}
								this.isLoading = false;

							}, error => {
								console.error(error)
							})

					} else {
						this.$alertify.error(result.data.message);
					}
					this.isLoading = false;

				}, error => {
					console.error(error)
				})
		},

		// Getting the Associated AWB ANd Courier
		getDataForMarkRto(data) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.srMarkedFlag == true) {
				this.$alertify.error(this.$t('rejectlistrto.RVPmarked'));
				return false;
			} else {
				this.poid = data.poid;
				this.shippingid = data.shippingid;
				this.merchantid = data.merchantid;
				this.shippingData = [];
				var i = 0;
				var allorders = '';
				this.input = ({
					shippingid: this.shippingid,
					clientid: localStorage.getItem("selectedClient"),
				})
				//this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getorderAssociatedAWB',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						var invalidFlag = true;
						if (result.data.errorCode == 0) {
							var awblist = result.data.data
							for (i = 0; i < result.data.count; i++) {
								if (awblist[i].shipmentstatus == 'dispatched') {
									this.shippingData.push({
										awbnumber: awblist[i].awbno,
										couriername: awblist[i].shippingcompany,
										shippingid: awblist[i].shippingid,
									});
									if (i == 0 || awblist[i - 1].awbno != awblist[i].awbno) {
										this.shippingDataInscan.push({
											orderid: this.poid,
											awbno: awblist[i].awbno,
											clientid: localStorage.getItem("selectedClient"),
											warehouseid: localStorage.getItem("selectedWarehouse"),
											transporter: awblist[i].shippingcompany,
											customerfirstname: awblist[i].customerfirstname,
											customerlastname: awblist[i].customerlastname,
											useremail: this.loginUserEmail
										});
									}

								} else if (awblist[i].shipmentstatus == 'rto') {
									this.$alertify.error(this.$t('rejectlistrto.rtoMarked'));
									return false;
								} else {
									invalidFlag = false;
									break;
								}
							}
							if (invalidFlag == true) {
								this.addmodalShow = true;
							} else {
								this.$alertify.error(this.$t('rejectlistrto.handoverNotCompleted'));
								return false;
							}
						} else {
							this.$alertify.error(this.$t('rejectlistrto.packingProcessNotDone'));
							return false;
						}
					}, error => {
						console.error(error)
					})
			}

		},

		saveMarkRto() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;

			if (this.shippingcompany == "") {
				var courierCompany = this.shippingData[0].couriername;
			} else {
				var courierCompany = this.shippingcompany;
			}


			var i = 0;
			var allorders = '';
			this.input = ({
				useremail: this.loginUserEmail,
				clientid: localStorage.getItem("selectedClient"),
				orderid: this.poid,
				shippingid: this.shippingid,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				shippingcompany: courierCompany,
				merchantid : this.merchantid != null ? this.merchantid : 0,
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'savemarkRTO',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(async result => {
					var response = result.data.errorCode
					if (response == 0) {
						//if (this.rtoInscan == 'yes') {
							// Now Making the Inscan Process
							await this.getDataInscanRto();
						//}
						this.isLoading = false;
						this.getOrderList();
						this.$alertify.success(result.data.msg);
					} else {
						this.$alertify.error(result.data.msg);
					}
				}, error => {
					console.error(error)
				})
		},

		getDataInscanRto() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var self = this;
			this.shippingDataInscan.forEach(function(item) {
				// Now looping here to get the information
				var inputData = ({
					awbno: item.awbno,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					couriername: item.transporter,
				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'checkawbnoReturn',
						'data': inputData,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(async (awbData) => {
						//console.log(awbData);return false;
						var awbData = awbData.data;
						var shippingid = {};
						shippingid = awbData.data.shippingid;
						var sku = awbData.data.sku;
						var totalquantity = awbData.data.totalquantity;
						// await this.saveInscanRTO(item.awbno, item.transporter, shippingid, sku, totalquantity, item.customerfirstname, item.customerlastname, item.warehouseid, item.clientid);
						var inputData = ({
							orderid: item.orderid,
							awbno: item.awbno,
							customerfirstname: item.customerfirstname,
							customerlastname: item.customerlastname,
							transporter: item.transporter,
							createdby: item.useremail,
							createddatetime: self.dateFormat(new Date()),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							boxcondition: 'Good',
							sku: sku,
							quantity: totalquantity,
							shippingid: shippingid,
							clientid: localStorage.getItem("selectedClient"),
							merchantid : self.merchantid != null ? self.merchantid : 0,
						});

						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'SaveRTO',
								'data': inputData,
								headers: {
									'Authorization': 'Bearer ' + myStr
								}
							})
							.then(result => {
								// success
								return true;
							})

					})

			})

			return true;

		},

		saveInscanRTO(awbno, transporter, shippingid, sku, totalquantity, customerfirstname, customerlastname, warehouseid, clientid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			var inputData = ({
				orderid: this.poid,
				awbno: awbno,
				customerfirstname: customerfirstname,
				customerlastname: customerlastname,
				transporter: transporter,
				createdby: this.loginUserEmail,
				createddatetime: dateFormat(new Date()),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				boxcondition: 'Good',
				sku: sku,
				quantity: totalquantity,
				shippingid: shippingid,
				clientid: localStorage.getItem("selectedClient")
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'SaveRTO',
					'data': inputData,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					return true;
				}, error => {
					console.error(error)
				})
		},
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// //to get Client list
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.clientListData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid ? this.warehouseid : '',
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.clientListData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchant = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 		    this.item={}
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.getMerchantList();
		// 			// this.getPOPutawayReportData();
		// 		}
		// 	}
		// 	this.listOrderData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			//this.getOrderList();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		closertoMarkModal() {
			this.addmodalShow = false
		},
		getcourierList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({});

			axios({
					method: 'GET',
					'url': apiUrl.api_url + 'courierlistRTO',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listCourierData = result.data.rows;
				}, error => {
					console.error(error)
				})
		},


		//to reset search form
		resetSearchForm1() {
			this.orderids = '';
			this.listOrderData = [];
			this.searchFlag = false;
			document.getElementById("orderids").value = "";
		},
		//to reset search form
		resetSearchForm() {
			this.totalRows = 0;
			this.orderids = '';
			// this.clientid = '';
			this.item={};
			this.shippingDataInscan = [];
			this.listOrderData = [];
			this.searchFlag = false;
			this.poid = '';
			this.shippingid = '';
			this.awbno = '';
			document.getElementById("awbno").value = "soumen";
			this.shippingcompany = '';
			this.resultCount = 0;
			document.getElementById("orderids").value = "";
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},

		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10
		// 	this.getOrderList()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getOrderList()
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/rtomarked/markrto/markrto.component.js